<template>
    <v-row class="white-card px-3">
        <v-col cols="12">
            <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
        </v-col>
        <v-col cols="12" class="headline-heavy text-center">
            Resumen de tu orden
        </v-col>
        <v-col cols="12" class="subtitle-profile">
            Solo queda un último paso
            <v-divider class="divider-secondary mt-2"/>
        </v-col>
        <v-col cols="12" class="subheader-heavy primary-color">
            <v-row align="center">
                <v-col cols="12" md="8">
                    Orden Médica ({{ currentExams.length || 0 }} examenes)
                </v-col>
                <v-col cols="12" md="4" :align="isMobile ? 'center' : 'right'">
                    <v-btn color="primary" large outlined class="normal-btn" @click="showPreview">
                        <v-img :src="require('@/assets/icons/file_medical_blue.png')" width="30" class="mr-2"/>
                        Ver Orden
                    </v-btn>
                </v-col>
            </v-row>
            <order-dialog :current-order="orders" :user="currentUser" ref="orderView"/>
            <v-divider class="divider-secondary mt-6"/>
        </v-col>
        <template v-if="!isClientOfCompany">
            <v-col cols="12" class="subheader-heavy primary-color">
                Sucursal
            </v-col>
            <v-col cols="12">
                <branch-office-combobox
                    label="Seleccionar Sucursal"
                    @change="branchOffice = $event"
                    :value="branchOffice"
                    :items="branchOffices"
                    :loading="loadingBranchOffices"
                    outlined dense
                />
                <v-divider class="divider-secondary mt-6"/>
            </v-col>
        </template>
        <v-col cols="12" class="text-center my-4">
            <v-btn color="primary" outlined x-large depressed class="normal-btn mr-3" @click="onBack">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn color="secondary" x-large depressed class="normal-btn" @click="sendOrder" :loading="loading">
                Enviar
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

import httpService from "@/services/httpService";
import OrderDialog from "@/components/orders/OrderDialog";
import BranchOfficeCombobox from "@/components/common/BranchOfficeCombobox";
import {ROLES} from "@/utils/Constants";

export default {
    name: "ClientResumeStepper",
    components: {BranchOfficeCombobox, OrderDialog},
    props: {
        exams: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            emissionOptions: [],
            branchOffices: [],
            loading: false,
            loadingBranchOffices: false,
            branchOffice: null,
        }
    },
    computed: {
        currentExams(vm = this) {
            if (!vm.packs) return vm.exams
            let exams = vm.exams.filter(exam => !exam.isPack)
            vm.packs.forEach(pack => {
                exams.push(...pack.exams)
            })
            return [...new Map(exams.map(item => [item.id, item])).values()]
        },
        packs(vm = this) {
            return vm.exams.filter(exam => !!exam.isPack)
        },
        orders(vm = this) {
            let orders = []
            vm.emissionOptions.forEach(emission => {
                let exams = vm.currentExams.filter(ex => ex.emission.id === emission.id)
                if (exams.length > 0) orders.push({title: emission.name, exams: exams})
            })
            return orders
        },
        isClientOfCompany(vm = this) {
            return vm.currentEntity?.role_id === ROLES.COMPANY
        }
    },
    async mounted() {
        const vm = this
        await vm.loadEmissions()
        if (!vm.isClientOfCompany) await vm.loadBranchOfficesByExams()
    },
    methods: {
        async loadEmissions() {
            const vm = this
            let response = await httpService.get('emissions')
            vm.emissionOptions = response.data.emissions
        },
        async loadBranchOfficesByExams() {
            const vm = this
            vm.loadingBranchOffices = true
            let response = await httpService.post('branch-offices-filter', {
                laboratory_id: vm.currentEntityId,
                exams: vm.getIdsFromArray(vm.currentExams),
            })

            vm.branchOffices = response.data.branch_offices
            vm.loadingBranchOffices = false
        },
        async sendOrder() {
            const vm = this
            if (!vm.branchOffice && !vm.isClientOfCompany) return vm.toast('Necesita seleccionar una toma de muestras para enviar su orden', 'error')
            vm.loading = true

            let payload = {
                laboratory_id: vm.currentEntityId,
                user_id: vm.currentUser.id,
                items: {
                    exams: vm.getIdsFromArray(vm.currentExams),
                    packs: vm.getIdsFromArray(vm.packs),
                },
            }

            if (vm.isClientOfCompany) payload.company_id = vm.currentEntityId
            else payload.branch_office_id = vm.branchOffice?.id || null

            await httpService.post('orders/create', payload)

            vm.loading = false
            vm.$emit('success')
        },
        showPreview() {
            const vm = this
            vm.$refs.orderView.show()
        },
        onBack() {
            const vm = this
            vm.$emit('back')
        }
    },
    watch: {
        exams() {
            this.loadBranchOfficesByExams()
        },
        currentEntity(val) {
            if (val && !this.isClientOfCompany) this.loadBranchOfficesByExams()
        }
    }
}
</script>

<style scoped>

.subtitle-profile {
    font-size: 14px;
    line-height: 16px;
    color: #939BB3;
}

</style>